import { render, staticRenderFns } from "./DeviceList.vue?vue&type=template&id=15af7950"
import script from "./DeviceList.vue?vue&type=script&lang=js"
export * from "./DeviceList.vue?vue&type=script&lang=js"
import style0 from "./DeviceList.vue?vue&type=style&index=0&id=15af7950&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports